// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* General resets */
.login-page-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.background-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.floating-logo {
  position: absolute;
  border-radius: 50%;
  opacity: 0.4;
  animation: floatUp infinite linear;
  will-change: transform;
}

@keyframes floatUp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
  }
}


.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #F2F2F2;
  align-items: center;
  height: 100vh; /* Take full viewport height */
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden; /* Prevent scroll */
  text-align: center;
}

.headline-text {
  font-size: 20px;
  font-weight: bold;
  color: #373435;
  line-height: 1.5;
  text-align: center;
  max-width: 70%;
  margin-top: 0;
}

.services {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2rem; 
}

.service-box {
  border: 1px solid #44a67e;
  color: #44a67e;
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: bold;
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
}

.service-box:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  color: #44a67e;
  font-weight: 600;
  transform: scale(1.05);
}

.login-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 2rem 2rem 0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(255, 204, 41, 0.6);
  text-align: center;
  /* max-width: 350px; */
  max-width: 400px;
  height: 55%;
  width: 80%;
  z-index: 1;
}

.otp-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  text-align: center;
  /* max-width: 350px; */
  max-width: 400px;
  height: 60%;
  width: 80%;
  z-index: 1;
}

.login-box h2 {
  color: #373435;
  font-size: 30px;
  margin-bottom: 35px;
  margin-top: -10px;
}

.login-form {
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 20px
}

.login-logo {
  width: 60px;
  margin-bottom: 1rem;
  margin-top: 10px;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #373435;
  font-weight: bold;
}

.form-group input {
  width: 100% !important;
  padding: 8px 10px !important;
  border: 1px solid #d1d1d1 !important;
  border-radius: 4px !important;
  font-size: 1rem;
}

input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 204, 41, 0.6);
}

.login-button {
  margin-left: auto;
  margin-right: auto;
  background-color: #44a67e;
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  margin-top: 10px;
}

.otp-form-group input {
  width: 100%;
  font-size: 24px;
  letter-spacing: 1.5em; 
  padding-left: 0.5em;
  text-align: center;
  border: none !important;
  border-bottom: 2px solid #ccc;
  outline: none;
  background: transparent;
}

.otp-form-group input:hover {
  border: none !important;
}

.otp-form-group input::placeholder {
  color: #ccc;
  letter-spacing: 1.5em;
  font-weight: bold;
}


.otp-button {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: #44a67e;
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.login-button:hover,
.otp-button:hover {
  background-color: #fff;
  color: #44a67e;
  box-shadow: 0 0 0 2px #44a67e;
  font-weight: 600;
}

.no-otp-text {
  color: #ccc !important;
}

.no-otp-text:hover {
  color: #373435 !important;
  cursor: pointer;
}

.otp-title {
  margin-bottom: 1rem;
  font-size: 1.8rem;
  color: #373435;
}

.otp-box p {
  color: #373435;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
}

.otp-input {
  width: 4rem;
  letter-spacing: 0.5rem;
  text-align: center;
  padding: 0.75rem;
  border: 2px solid #373435;
  border-radius: 4px;
  font-size: 1.5rem;
  font-weight: bold;
  background-color: #fff;
  color: #373435;
}

.icon-container {
  color: #373435;
}

.username-wrapper input {
  box-sizing: border-box;
}

.password-wrapper {
  position: relative;
  width: 100%;
}

.password-wrapper input {
  width: 100%;
  padding-right: 40px; /* Make space for the eye icon */
  box-sizing: border-box;
}

.eye-icon {
  position: absolute;
  top: 50%;
  right: 10px; /* Position it 10px from the right */
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
  font-size: 18px;
}

.eye-icon:hover {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":";;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,4CAA4C;EAC9C;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa,EAAE,8BAA8B;EAC7C,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,mBAAmB;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,gCAAgC;EACrD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,oCAAoC;EACjD,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb","sourcesContent":["\r\n\r\n/* General resets */\r\n.login-page-wrapper {\r\n  position: relative;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.background-icons {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 0;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n}\r\n\r\n.floating-logo {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  opacity: 0.4;\r\n  animation: floatUp infinite linear;\r\n  will-change: transform;\r\n}\r\n\r\n@keyframes floatUp {\r\n  0% {\r\n    transform: translateY(0px) rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: translateY(-100vh) rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n.login-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  background-color: #F2F2F2;\r\n  align-items: center;\r\n  height: 100vh; /* Take full viewport height */\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  overflow: hidden; /* Prevent scroll */\r\n  text-align: center;\r\n}\r\n\r\n.headline-text {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #373435;\r\n  line-height: 1.5;\r\n  text-align: center;\r\n  max-width: 70%;\r\n  margin-top: 0;\r\n}\r\n\r\n.services {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  margin-bottom: 2rem; \r\n}\r\n\r\n.service-box {\r\n  border: 1px solid #44a67e;\r\n  color: #44a67e;\r\n  padding: 8px 14px;\r\n  border-radius: 6px;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  font-size: 1rem;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.service-box:hover {\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  color: #44a67e;\r\n  font-weight: 600;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.login-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  padding: 2rem 2rem 0;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 12px rgba(255, 204, 41, 0.6);\r\n  text-align: center;\r\n  /* max-width: 350px; */\r\n  max-width: 400px;\r\n  height: 55%;\r\n  width: 80%;\r\n  z-index: 1;\r\n}\r\n\r\n.otp-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  /* max-width: 350px; */\r\n  max-width: 400px;\r\n  height: 60%;\r\n  width: 80%;\r\n  z-index: 1;\r\n}\r\n\r\n.login-box h2 {\r\n  color: #373435;\r\n  font-size: 30px;\r\n  margin-bottom: 35px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.login-form {\r\n  width: 90%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px\r\n}\r\n\r\n.login-logo {\r\n  width: 60px;\r\n  margin-bottom: 1rem;\r\n  margin-top: 10px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1rem;\r\n  text-align: left;\r\n}\r\n\r\nlabel {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  color: #373435;\r\n  font-weight: bold;\r\n}\r\n\r\n.form-group input {\r\n  width: 100% !important;\r\n  padding: 8px 10px !important;\r\n  border: 1px solid #d1d1d1 !important;\r\n  border-radius: 4px !important;\r\n  font-size: 1rem;\r\n}\r\n\r\ninput:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(255, 204, 41, 0.6);\r\n}\r\n\r\n.login-button {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background-color: #44a67e;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-in-out;\r\n  margin-top: 10px;\r\n}\r\n\r\n.otp-form-group input {\r\n  width: 100%;\r\n  font-size: 24px;\r\n  letter-spacing: 1.5em; \r\n  padding-left: 0.5em;\r\n  text-align: center;\r\n  border: none !important;\r\n  border-bottom: 2px solid #ccc;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.otp-form-group input:hover {\r\n  border: none !important;\r\n}\r\n\r\n.otp-form-group input::placeholder {\r\n  color: #ccc;\r\n  letter-spacing: 1.5em;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.otp-button {\r\n  margin-top: 20px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  background-color: #44a67e;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.login-button:hover,\r\n.otp-button:hover {\r\n  background-color: #fff;\r\n  color: #44a67e;\r\n  box-shadow: 0 0 0 2px #44a67e;\r\n  font-weight: 600;\r\n}\r\n\r\n.no-otp-text {\r\n  color: #ccc !important;\r\n}\r\n\r\n.no-otp-text:hover {\r\n  color: #373435 !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.otp-title {\r\n  margin-bottom: 1rem;\r\n  font-size: 1.8rem;\r\n  color: #373435;\r\n}\r\n\r\n.otp-box p {\r\n  color: #373435;\r\n  margin-bottom: 1rem;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.otp-input {\r\n  width: 4rem;\r\n  letter-spacing: 0.5rem;\r\n  text-align: center;\r\n  padding: 0.75rem;\r\n  border: 2px solid #373435;\r\n  border-radius: 4px;\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  background-color: #fff;\r\n  color: #373435;\r\n}\r\n\r\n.icon-container {\r\n  color: #373435;\r\n}\r\n\r\n.username-wrapper input {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.password-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.password-wrapper input {\r\n  width: 100%;\r\n  padding-right: 40px; /* Make space for the eye icon */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.eye-icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 10px; /* Position it 10px from the right */\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  color: #888;\r\n  font-size: 18px;\r\n}\r\n\r\n.eye-icon:hover {\r\n  color: #333;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
